import { ActionHandlerMap, IMap, IUserState } from '../../../types'
import { createActionHandler, mergeMap } from '../../../utils/state'
import { ICurrentUser, IUserAction, IUsersSaveAction } from '../../actions/users'
import {
  CURRENT_USER_SUCCESS,
  TEAM_MEMBER_FETCH_SUCCESS,
  TEAM_MEMBER_LIST_SUCCESS,
  USERS_SUCCESS
} from '../../constants'
import { ISuccessAction } from '../../actions/common'
import { IStateUser } from '../../../types/user'

const initialStore: IUserState = {
  items: {},
  currentUserId: undefined
}

const actionReducerStrategy: ActionHandlerMap<IUserState, IUserAction> = {
  SAVE_USERS: {
    filter: ({ type }: IUserAction): boolean => [TEAM_MEMBER_LIST_SUCCESS, TEAM_MEMBER_FETCH_SUCCESS].includes(type),
    reduce: (state: IUserState, action: IUsersSaveAction) => ({
      ...state,
      items: mergeMap(state.items, action.users)
    })
  },
  CURRENT_USER_SUCCESS: {
    filter: ({ type }: IUserAction): boolean => CURRENT_USER_SUCCESS === type,
    reduce: (state: IUserState, action: ICurrentUser) => {
      return {
        ...state,
        currentUserId: action.userId
      }
    }
  },
  USERS_SUCCESS: {
    filter: ({ type }: ISuccessAction): boolean => USERS_SUCCESS === type,
    reduce: (state: IUserState, action: ISuccessAction<IMap<IStateUser>>) => {
      return {
        ...state,
        items: { ...state.items, ...action.data }
      }
    }
  }
}

const user = createActionHandler(actionReducerStrategy, initialStore)

export default user



// WEBPACK FOOTER //
// ./src/state/reducers/users/index.ts